const STORAGE = 'localStorage';
const MOBILE_FILTERS_KEY = 'mobileFiltersState';
const THIRTY_MINUTES_IN_MILLISECONDS = 30 * 60 * 1000;

type MobileFiltersState = {
    visitCount?: number;
    lastUpdated?: number;
};

export function computeMobileFiltersOpen(isProbablyMobile: boolean): boolean {
    if (!isProbablyMobile) {
        return false;
    }

    const epoch = new Date(0).valueOf();
    const now = new Date().valueOf();

    try {
        const { visitCount = 0, lastUpdated = epoch }: MobileFiltersState =
            JSON.parse(window[STORAGE].getItem(MOBILE_FILTERS_KEY) ?? '{}');

        const isFirstTimeVisit = visitCount < 3;
        const isNewSession = now - lastUpdated > THIRTY_MINUTES_IN_MILLISECONDS;
        const isNewFirstTimeSession = isFirstTimeVisit && isNewSession;

        if (isNewFirstTimeSession) {
            const updatedState: MobileFiltersState = {
                visitCount: visitCount + 1,
                lastUpdated: now,
            };
            window[STORAGE].setItem(
                MOBILE_FILTERS_KEY,
                JSON.stringify(updatedState),
            );
        }

        return isNewFirstTimeSession;
    } catch {
        return false;
    }
}
